import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const pouchTypeSchema = z
    .union([
    z.literal("Stand-Up Pouch"),
    z.literal("Quad Seal"),
    z.literal("3-Side Seal"),
    z.literal("2-Side Seal"),
    z.literal("Pillow Pouch"),
    z.literal("Top Spout"),
    z.literal("Corner Spout"),
    z.literal("Side Gusset Pouch"),
    z.literal("Rollstock").describe(createCustomSettings({ hide: true })),
    z.literal("Flat Bottom Bag"),
])
    .describe("Pouch Type");
//# sourceMappingURL=pouchType.js.map